import { Switch } from "@clockwise/design-system";
import { FormatAlignJustify, FormatIndentIncrease } from "@clockwise/icons";
import { Tooltip } from "@material-ui/core";
import classNames from "classnames";
import React from "react";
import { useReadProposalOptionsOverlay } from "../../chat-plus-calendar/util/ProposalOptionsOverlayContext";
import { useProposalOptionsOverlayToggle } from "./useProposalOptionsOverlayToggle";

export const ProposalOptionsOverlayToggle = ({
  overlayVisible,
  onToggle,
  showVariants,
}: {
  overlayVisible: boolean;
  onToggle: () => void;
  showVariants: boolean;
}) => {
  const { toggleVariant, isOverlayVisible, showOverlayToggle } = useProposalOptionsOverlayToggle();
  const { variant } = useReadProposalOptionsOverlay();

  if (!showOverlayToggle) return null;

  const Label = () => <div className="cw-flex cw-w-[115px] cw-body-sm">Show suggestions</div>;

  const isRailVariant = variant === "rail";

  const showCollapsedIcon = showVariants && isOverlayVisible;

  return (
    <div className="cw-relative cw-z-[40]">
      <div
        className={classNames(
          "cw-mt-2 cw-px-3 cw-py-1.5 cw-absolute cw-bg-default cw-rounded-xl cw-left-[calc(50%-62px)] cw-drop-shadow-md cw-flex cw-items-center",
          "cw-border-[0.5px] cw-border-solid cw-border-muted cw-drop-shadow-md",
          { "cw-py-2": !showCollapsedIcon },
        )}
      >
        <Switch
          checked={overlayVisible}
          onChange={onToggle}
          label={<Label />}
          labelPlacement="end"
          size="small"
        />
        {showCollapsedIcon && (
          <>
            <div className="cw-flex cw-h-5 cw-w-[1px] cw-border-l cw-border-solid cw-border-subtle cw-mx-1" />
            <div onClick={toggleVariant}>
              {isRailVariant ? (
                <Tooltip title="Expanded view">
                  <FormatIndentIncrease className="cw-w-4 cw-h-4 cw-text-muted cw-cursor-pointer cw-mt-1 hover:cw-text-muted-hover cw-ml-0.5" />
                </Tooltip>
              ) : (
                <Tooltip title="Collapsed view">
                  <FormatAlignJustify className="cw-w-4 cw-h-4 cw-text-muted cw-cursor-pointer cw-mt-1 hover:cw-text-muted-hover cw-ml-0.5" />
                </Tooltip>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
